export const DEMO = {
  RENDER_SIZE_WIDTH: 1920,
  RENDER_SIZE_HEIGHT: 1080,
  TURNTABLE: {
    MOUSE_SENSIBILITY: 2,
    TOTAL_FRAMES: 72,
    // CAMERA_NAME_PREFIX: "turn_EXT_",
  },
  TRANSITIONS: {
    SLOW: { type: "spring", stiffness: 200, damping: 100 },
    GESCHMEIDIG: { type: "spring", stiffness: 200, damping: 50 },
    FAST: { type: "spring", stiffness: 400, damping: 50 },
  },
  INITIAL: {
    ENV: 0,
    CAM: 0,
    TURN_FRAME: 0,
    FALLBACK_TIME: 15,
    FALLBACK_NORTH_YAW: 15,
  },
};

export const createGL = (canvas: any) => {
  canvas.width = DEMO.RENDER_SIZE_WIDTH;
  canvas.height = DEMO.RENDER_SIZE_HEIGHT;

  const gl =
    canvas.getContext("webgl", { preserveDrawingBuffer: true }) ||
    canvas.getContext("experimental-webgl", { preserveDrawingBuffer: true });
  gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
  const buffer = gl.createBuffer();

  gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, -1, 4, 4, -1]), gl.STATIC_DRAW);
  gl.viewport(0, 0, canvas.width, canvas.height);
  return gl;
};
